export const environment = {
  production: true,
  serverAddress: "https://lore-alvarado.strappberry.com",
  oneSignalAppId: '1698c769-2512-4b16-a652-852654729223',
};



// WEBPACK FOOTER //
// ./src/environment.ts